"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Warehouse` instead */
export const Warehouse = createSVGIcon(
  <g clipPath="url(#clip0_6654_975)" stroke="currentColor">
    <path
      d="M23.143 11.897a1.71 1.71 0 0 0-.549-1.268L12 .857 1.406 10.63a1.72 1.72 0 0 0-.549 1.268v9.532a1.714 1.714 0 0 0 1.715 1.714h18.857a1.715 1.715 0 0 0 1.714-1.714z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.429 17.145h5.14s.43 0 .43.428v5.141s0 .429-.43.429h-5.14s-.429 0-.429-.429v-5.14s0-.43.429-.43ZM9.429 11.145h5.14s.43 0 .43.428v5.141s0 .429-.43.429H9.43s-.429 0-.429-.429v-5.14s0-.43.429-.43Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.43 17.145h5.141s.429 0 .429.428v5.141s0 .429-.429.429h-5.14s-.43 0-.43-.429v-5.14s0-.43.43-.43Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>,
  "Warehouse",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
